import { render } from "./ProjectDocuments.vue?vue&type=template&id=0ea97d33&scoped=true"
import script from "./ProjectDocuments.vue?vue&type=script&lang=js"
export * from "./ProjectDocuments.vue?vue&type=script&lang=js"

import "./ProjectDocuments.vue?vue&type=style&index=0&id=0ea97d33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea97d33"]])

export default __exports__